import toast from 'react-hot-toast';
import apis from './apis';
import { clearAuth, getRefreshToken, getToken, setAuth } from './auth';

let refreshingPromise = null;

async function refreshSession() {
  if (!refreshingPromise) {
    refreshingPromise = fetch(apis().authRefresh, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ refreshToken: getRefreshToken() }),
    })
      .then(async (response) => {
        const result = await response.json().catch(() => ({}));
        if (!response.ok || !result?.status) throw new Error(result?.message || 'Session expired');
        setAuth(result);
        return result;
      })
      .finally(() => {
        refreshingPromise = null;
      });
  }
  return refreshingPromise;
}

const httpAction = async (data) => {
  const makeRequest = async (retry = false) => {
    const headers = data.formData ? {} : { 'Content-Type': 'application/json' };
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(data.url, {
      method: data.method || 'GET',
      body: data.formData ? data.formData : data.body ? JSON.stringify(data.body) : null,
      headers,
      credentials: 'include',
    });

    const result = await response.json().catch(() => ({}));

    if (response.status === 401 && !retry && getRefreshToken()) {
      await refreshSession();
      return makeRequest(true);
    }

    if (!response.ok) {
      const error = new Error(result?.message || 'Request failed');
      error.status = response.status;
      throw error;
    }

    return result;
  };

  try {
    return await makeRequest(false);
  } catch (error) {
    if (error.status === 401) clearAuth();
    if (!data.silent) toast.error(error.message || 'Something went wrong');
    return { status: false, message: error.message, code: error.status };
  }
};

export default httpAction;
